// import CountUp from "countup";
import { CountUp } from "countup.js";

class CountUpElement extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }


  init() {
    const originalNum = this.innerText.trim();
    if (!originalNum.match(/[0-9]+/) || originalNum.indexOf('/') != -1) return;

    const prefix = originalNum.match(/[^0-9,.]*/) ? originalNum.match(/[^0-9,.\/]*/)[0] : '';
    const suffix = originalNum.match(/[^0-9,.]*$/) ? originalNum.match(/[^0-9,.\/]*$/)[0] : '';
    const parsedNum = originalNum.match(/[0-9,.]+/)[0].replace(',','');
    const decimalPlaces = originalNum.match(/[.][0-9]+/) ? String(originalNum.match(/[0-9,.]+/)[0].split(".")[1]).length : 0;

    this.countUp = new CountUp(this, parsedNum, {
      decimalPlaces,
      duration: 3,
      enableScrollSpy: true,
      prefix,
      suffix,
    });
  }
}

customElements.define("count-up", CountUpElement);

document.addEventListener("DOMContentLoaded", () => {
  window.countUpObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {

      if (entry.intersectionRatio > 0 && entry.target.countUp && !entry.target.countUp.error) {
        entry.target.countUp.reset();
        entry.target.countUp.start();
      }
    })
  });

  document.querySelectorAll('count-up').forEach(countUp => {
    window.countUpObserver.observe(countUp);
  });
});
